module.exports = __webpack_public_path__ + "static/media/Portrait-10075.1d18db2b.jpg";